import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';

export const getMealFeatures = ({ showFlexibleAlternativeDates, meal }: GetFeaturesInnerParams): Feature[] => {
  if (!showFlexibleAlternativeDates) {
    return meal
      ? [
          {
            text: meal,
            className: 'meal',
            featureType: FeatureType.normal,
          },
        ]
      : [];
  }

  return [];
};
